import DatasetGps from "@/modules/dataset-gps";
import { useInterventionSectionDatasetGps } from "@/modules/intervention/intervention-section-datasets";

const InterventionSectionGps = () => {
  const { key, disabled, dataset, template, loading } =
    useInterventionSectionDatasetGps();

  return (
    <DatasetGps
      key={key}
      disabled={disabled}
      dataset={dataset}
      template={template}
      loading={loading}
    />
  );
};

export default InterventionSectionGps;
